
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";

import { ImageIcon } from "../Icons/ComponentIcons";
import React from "react";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import CreateAttributeList, { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, getNodeRootStyleAttributeValue, getNodeStyleAttributeValue, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import WebDesigner from "../WebDesigner";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { ApplyLinkAttributes, GetLinkFromLinkAttribute } from "vagaro-website-rendering/src/components/ComponentRenders/RenderButton";
import GetImageURLWithResolution from "vagaro-website-rendering/src/components/Utilities/GetImageURLWithResolution";
import NodeCanBeLink from "../Utilities/NodeCanBeLink";





function ImagePlaceHolderSvg(props:{}){

return(

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#333333">

     <path d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/></svg>

)

}



export default class WBImage extends WBComponent {



    constructor(){
        super();
        this.typename = wBComponentTypeNames.image;
        this.displayName = "Image";
        this.dropList = defaultDropList;
        this.editList = ["imageSrc","linkOpenType","altText",attributeTypes.position,attributeTypes.objectPosition,attributeTypes.objectFit,"cLink",...CreateAttributeList(true,false,false,true,false),componentAttributeTypes.customCSS];
        this.primaryEditAttributes = ["imageSrc","altText",attributeTypes.objectFit,attributeTypes.objectPosition,"cLink"];
        this.icon = <ImageIcon/>
        this.defaultGridSize = {width:240,height:240};
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

        return [
           new AttributeDefinition("imageSrc","Image","",AttributeInputType.ImageField),
           new AttributeDefinition("altText","Alternative Text","",AttributeInputType.InputFiled)
        ]
    }


    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeStyleAttributeValue(thisLayout,ScreenSize.Desktop,"height","240px");
        setNodeStyleAttributeValue(thisLayout,ScreenSize.Desktop,"width","240px");

    }
   RenderLayout({ component, children, screenSize,isEditor,userContext: siteData }: WBRenderProps): JSX.Element {


    const lnk = getNodeComponentAttributeValue(component,"cLink","");
    let openType = getNodeComponentAttributeValue(component,"linkOpenType","_self")??"_self";
    const isLink = lnk&&lnk.length>1;
       let imageSrc = component.componentAttributes["imageSrc"] ??"";
       let alt  = component.componentAttributes["altText"] ??"unnamed image";

        if(imageSrc.length<=0){


            return(


               <div {...GetNodeDomAttributes("v-image image-place-holder max-100 center-flex "+(isLink?"v-linked":""),component,screenSize,isEditor)}>
                   <ImagePlaceHolderSvg/>
               </div>
           )
        }


        if(!isEditor){

            let resolution = component.screenResolutions;
            imageSrc = GetImageURLWithResolution(imageSrc,resolution);
        }
        if(imageSrc.includes("var(--image")){

            let index = parseInt(imageSrc.replace("var(--image-","").replace(")",""));


            if(!isNaN(index)&&index>=0){
                imageSrc = siteData.imageMapping[index-1];

            }
        }


        if(isLink&&!isEditor&&NodeCanBeLink(component)){
          const realLink = GetLinkFromLinkAttribute(lnk,siteData.pages);

            const atts = GetNodeDomAttributes("v-image max-100 ",component,screenSize,isEditor) as any;
            let tstAtts = GetNodeDomAttributes("",component,screenSize, isEditor,true) as any;

            let linkAtts = ApplyLinkAttributes(lnk,component,tstAtts);

            let classes = atts.className.split(" ");
            let newStr = "";

            for(let i = 0;i<classes.length;i++){

                if(classes[i].includes("vwb-mrg-")){
                    newStr+=classes[i]+" ";
                    classes.splice(i,1);
                    i--;
                }
                else if(classes[i].includes("vwb-wdth")){
                    newStr+=classes[i]+" ";
                    classes.splice(i,1,"w-full");

                }
                else if(classes[i].includes("vwb-hght")){
                    newStr+=classes[i]+" ";
                    classes.splice(i,1,"h-full");

                }



            }

            atts.className = classes.join(" ");


          return <a  href={realLink} target={openType} {...linkAtts} className={"max-100 hierarchy no-a flex-row "+newStr+" "+linkAtts.className} >
                <img  loading="lazy" src={imageSrc} alt={alt}{...atts} />
             </a>



        }


        if(isLink&&isEditor){
            let atts = GetNodeDomAttributes("v-image max-100 v-linked ",component,screenSize,isEditor) as any;
            let style = {...atts.style};
            atts.style = {};
            atts.style.margin = style.margin;
            atts.style.padding = style.padding;
            atts.style.width = style.width;
            atts.style.height = style.height;
            style.height = "100%";
            style.width = "100%";

           return  <div {...atts}>
                <img style={style} className="v-image max-100" loading="lazy" src={imageSrc} alt={alt} />
            </div>

        }

       return (

   <>
           <img loading="lazy" src={imageSrc} alt={alt}{...GetNodeDomAttributes("v-image max-100 "+(isLink?" v-linked":""),component,screenSize,isEditor)} />


     </>
       )


   }



}